export default __webpack_public_path__ + "media/src/assets/images/editPenn-ac580539351111749d100636422a56d1.svg";